import {Injectable} from '@angular/core';
import {BehaviorSubject, Subject} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EventEmitterService {
  openPaymentModal = new Subject<any>();
  openPaymentSiteDetails = new Subject<string>();
  updateFiles = new Subject<boolean>();
  hasSubmittedOrder = new BehaviorSubject<boolean>(true);
  closeDrawer = new Subject<boolean>();
  loadedPaymentMethodForSubscription = new BehaviorSubject<boolean>(false);
  showForbiddenDialog = new Subject<boolean>();
  handleExpiredToken = new Subject<boolean>();
  updateHeaders = new Subject<boolean>();
}
